
import React, { useState, useEffect } from 'react';
import './index.css';
import image from "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from "./img/back.png";
import imageinfo from "./img/download-info.png";
import edit from "./img/edit.jpg";
import {GET_SEPERATIONDATALL,GET_SEPERATIONDATADMIN,NOCIT,NOCADMIN,NOCRM,GET_SEPERATIONDATARM} from "../../Pages/AppConstant";
import axios from "axios";
import Button from "react-bootstrap/Button";
const ExitRequestForm = () => {
//   const [formData, setFormData] = useState({
    
//     reason: '',
//     lastWorkingDay: '',
//     comments: '',
//     emailid: '',
//     assetid:''
//   });
const [seperationlist,setSeperationlist]= useState([]);
const [selectedseparationcode,setSelectedseparationcode]= useState("");
const [ismodelopen, setIsmodelopen] = useState(false);
const [istab,setIstab]= useState(1);
const [laptop,setLaptop]= useState("");
const [laptopcondition,setLaptopcondition]= useState("");
const [laptopadptor,setLaptopadptor]= useState("");
const [laptopadaptorcondition,setLaptopadaptorcondition]= useState("");
const [laptopbagcondition,setLaptopbagcondition]= useState("");
const [laptopbag,setLaptopbag]= useState("");
const [maingatetrydata,setMaingatetrydata]= useState("");
const [emaildeactivation,setEmaildeactivation]= useState("");
const [biometricpunchdata,setBiometricpunchdata]= useState("");
const [workstationkeydata,setWorkstationkeydata]= useState("");
const [handlechangeidcarddata,setHandlechangeidcarddata]= useState("");
const [handlechangefoodcardata,setHandlechangefoodcardata]= useState("");
const [pendingtaskdata,setPendingtaskdata]= useState("");
const [handingover,setHandingover]= useState("");
const [isdepartment,setIsdepartment]= useState(false);
const [isadmin,setIsadmin]= useState(false);
const [isreporting,setIsreporting]= useState(false);
const [isedited,setIsedited]= useState(false);
const [employeename,setEmployeename]= useState("");
 const [isverified, setIsverified] = useState("");
 const [isverfiednew, setIsverfiednew] = useState("");
 const [switch_code,setSwitch_code] = useState("");
 const [remarks,setRemarks]= useState("");
 const [ showit,setShowit]= useState(false);
 const [ showadmin,setShowadmin]= useState(false);
 const [empemailid,setEmpemailid]= useState("");
   useEffect(() => {
     callseparationlist();
     
    }, []);
  const redirectToLogin = () => {
        window.location.href = "/login"
    }
    const redirectTodashboard = () => {
        window.location.href = "/landingPage"
    }

   
//   const callsubmitfn=()=>{
//     formData.switch_code=localStorage.getItem('empid');
//     formData.requests="Initiated"
//     axios({
//             method: "post",
//             url: EXITREQUEST,
//             headers: { "Content-Type": "multipart/form-data" },
//             data: formData,
//           })
//             .then((response) => {
//               alert(response.data);
//             })
//             .catch((error) => {
//               console.error(error);
//             });
//     console.log(formData)
//   }
  const separatefn = (val)=>{
    // alert()
    // setIsmodelopen(true)
    // setSelectedseparationcode(val.switch_code)
    setSwitch_code(val.switch_code)
    setIsedited(true)
    setIstab(2) 
    setEmployeename(val.employee_name)
    setEmpemailid(val.official_emailid)
     if(localStorage.getItem("empid") =="300458" || localStorage.getItem("dept") =='IT'){
                     setIsdepartment(true)
                     if(localStorage.getItem("empid") ==val.manager_id ){
                     setIsreporting(true)
                }else{
                     setIsreporting(false)
                }
                }else{
                     setIsdepartment(false)
                }
                if(localStorage.getItem("empid") =="300440" || localStorage.getItem("dept") =="HR & Admin"){
                     setIsadmin(true)
                      if(localStorage.getItem("empid") ==val.manager_id ){
                     setIsreporting(true)
                }else{
                     setIsreporting(false)
                }
                }else{
                     setIsadmin(false)
                }
                 if(localStorage.getItem("empid") ==val.manager_id ){
                     setIsreporting(true)
                }else{
                     setIsreporting(false)
                }
                
   
  }

  const callseparationlist=()=>{
    if(localStorage.getItem("empid") =="300458" || localStorage.getItem("dept") =='IT'){
                     setShowit(true)
                }else{
                     setShowit(false)
                }
                if(localStorage.getItem("empid") =="300440" || localStorage.getItem("dept") =="HR & Admin"){
                     setShowadmin(true)
                }else{
                     setShowadmin(false)
                }

      axios({
            method: "get",
            url: GET_SEPERATIONDATALL,
            withCredentials: false,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Access-Control-Allow-Origin": "*",
            },
        params: { vendor_code: localStorage.getItem("empid") },
        
          })
            .then((response) => {
                setSeperationlist(response.data.data)
                if(response.data.data.length === 0){
                      axios({
                  method: "get",
                  url: GET_SEPERATIONDATADMIN,
                  withCredentials: false,
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Access-Control-Allow-Origin": "*",
                  },
        params: { vendor_code: localStorage.getItem("empid") },
            
              })
                .then((response) => {
                    setSeperationlist(response.data.data)
                     if(response.data.data.length === 0){
                axios({
                  method: "get",
                  url: GET_SEPERATIONDATARM,
                  withCredentials: false,
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Access-Control-Allow-Origin": "*",
                  },
        params: { vendor_code: localStorage.getItem("empid") },
            
              })
                .then((response) => {
                    setSeperationlist(response.data.data)

                        })
                .catch((error) => {
                  console.error(error);
                });
                     }
                  
                    // setVendorlist(response.data.data);
                })
                .catch((error) => {
                  console.error(error);
                });
                    }
                  
                    // setVendorlist(response.data.data);
                })
                .catch((error) => {
                  console.error(error);
                });
    }
    const enabletab=(e)=>{
          setIstab(e)   
    }

    const handlechangelaptop = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLaptop(selectdata);
    }
     const handlechangelaptopconditions = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLaptopcondition(selectdata);
    }
    const handlechangelaptopbag = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLaptopbag(selectdata);
    }
     const handlechangelaptopbagconditions = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLaptopbagcondition(selectdata);
    }
    const handlechangelaptopadaptor = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLaptopadptor(selectdata);
    }
     const handlechangelaptopadatorconditions = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLaptopadaptorcondition(selectdata);
    }

   const  handlechangeemaildeactive = (e)=>{
    let selectdata = e.target.value;
    setEmaildeactivation(selectdata);
   }
    
   const  handlechangefoodcard = (e)=>{
    let selectdata = e.target.value;
    setHandlechangefoodcardata(selectdata);
   }
    
   const  handlechangeidcard = (e)=>{
    let selectdata = e.target.value;
    setHandlechangeidcarddata(selectdata);
   }
    
   const  workstationkey = (e)=>{
    let selectdata = e.target.value;
    setWorkstationkeydata(selectdata);
   }
    
   const biometricpunch = (e)=>{
    let selectdata = e.target.value;
    setBiometricpunchdata(selectdata);
   }
    
   const maingatetry = (e)=>{
    let selectdata = e.target.value;
    setMaingatetrydata(selectdata);
   }
   const pendingtask = (e)=>{
     let selectdata = e.target.value;
    setPendingtaskdata(selectdata);
    } 

    const handincoverfn = (e)=>{
        let selectdata = e.target.value;
    setHandingover(selectdata);
    }
    


const checkedvalnew = (e) => {
    if (e == "verified") {
      setIsverfiednew("verified");
      let text =
        "Press a button!\nEither OK or Cancel. To confirm the verified";
      if (window.confirm(text) == true) {
        setIsverified("Yes");
        text = "You pressed OK!";
      } else {
        setIsverfiednew("notverified");

        setIsverified("No");
        text = "You canceled!";
      }
    } else {
      setIsverfiednew("notverified");
      setIsverified("No");
    }
  };
  const handleSubmit_it=()=>{
    let it_clearance;
    if(isverified=="Yes"){
      it_clearance = "NOC Cleared"
    }else{
      it_clearance = "NOC Not Cleared"
    }
    let charger = laptopadptor;
    let bag = laptopbag;
    let emailid_deactivation=emaildeactivation;
    let laptop_condition=laptopcondition;
    let bag_condition=laptopbagcondition;
    let charger_condition=laptopadaptorcondition;
    let it_status=remarks
     axios({
            method: "post",
            url: NOCIT,
            headers: { "Content-Type": "multipart/form-data" },
            data: {switch_code,it_clearance,laptop,charger,bag,emailid_deactivation,laptop_condition,bag_condition,charger_condition,it_status},
          })
            .then((response) => {
              alert(response.data);
              callseparationlist();
              setIstab(1)
            })
            .catch((error) => {
              console.error(error);
            });
  }
    const handleSubmit_admin=()=>{
      let admin_clearance;
      if(isverified=="Yes"){
      admin_clearance = "NOC Cleared"
    }else{
      admin_clearance = "NOC Not Cleared"
    }
    let food_card=handlechangefoodcardata
    let id_card=handlechangeidcarddata
    let drawer_key = workstationkeydata
    let biomatric =biometricpunchdata
    let  gate_entry =maingatetrydata
    let admin_status=remarks
      axios({
            method: "post",
            url: NOCADMIN,
            headers: { "Content-Type": "multipart/form-data" },
            data: {switch_code,food_card,id_card,drawer_key,biomatric,gate_entry,admin_status,admin_clearance},
          })
            .then((response) => {
              alert(response.data);
              callseparationlist();
              setIstab(1)
            })
            .catch((error) => {
              console.error(error);
            });
  } 
  const handleSubmit_rm=()=>{
      let reporting_manager_clearance;
      if(isverified=="Yes"){
      reporting_manager_clearance = "NOC Cleared"
    }else{
      reporting_manager_clearance = "NOC Not Cleared"
    }
   
    // let handingover =handingover
    let  pending_tasks =pendingtaskdata
    let rm_status=remarks
      axios({
            method: "post",
            url: NOCRM,
            headers: { "Content-Type": "multipart/form-data" },
            data: {switch_code,rm_status,pending_tasks,reporting_manager_clearance,handingover},
          })
            .then((response) => {
              alert(response.data);
              callseparationlist();
              setIstab(1)
            })
            .catch((error) => {
              console.error(error);
            });
  } 
  
  return (
   <div className="bg_set_usb">   
         <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/> 
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/> 
                 <h2>Third Party No Due Clerance</h2>
         <div className="row tabdesign-noc">
            <div className={istab==1?"col-md-2 tabfirst-selected-noc":"col-md-2 notselected-noc"} onClick={()=>enabletab(1)}>List</div>
            
                 <div className={istab==2?"col-md-2 tabfirst-selected-noc disabledtab":"col-md-2 notselected-noc disabledtab"} onClick={()=>enabletab(2)}>View </div> 
                </div> 
         {istab===1?       
        <div className="row noc_box2">
                      <table className="table-full mt-3">
                        <thead className="header-asset">
                          <tr>
                            <th>Sl.No</th>
                            <th>Switch Code</th>
                            <th>Employee Code</th>
                            <th>Employee Name</th>
                            {/* <th>DOJ</th> */}
                            <th>Work Location</th>
                            <th>Department</th>
                            {/* <th>Sub Department</th> */}
                            <th>Reporting Manager</th>
                            <th>NOC Status</th>
                            
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {seperationlist.length
                            ? seperationlist.map((val, i) => {
                                return (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{val.switch_code}</td>
                                    <td>{val.employee_code}</td>
                                    <td>{val.employee_name}</td>
                                    {/* <td>{val.doj}</td>  */}
                                    <td>{val.location}</td>
                                    <td>{val.department}</td>
                                    {/* <td>{val.sub_department}</td>  */}
                                    <td>{val.reporting_manager}</td>
                                     {/* <td>{val.exit_request}</td> */}
                                    <td>{showit?val.it_noc_status:showadmin?val.admin_noc_status:val.rm_noc_status}</td> 
                                    {/* <td>{val.contractor_name}</td> 
                                <td>{val.vendor_code}</td>  */}
                                   
                                    <td style={{ width: "10%" }}><img
                                        style={{ width: "20%", cursor: "pointer" }}
                                        onClick={(e) =>separatefn(val)}
                                        className=""
                                        src={edit}
                                        title="Edit"
                                      
                                      /></td>
      
                                    {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}
      
                                    {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                                  </tr>
                                );
                              })
                            : ""}
                        </tbody>
                      </table>
                
                    
    </div>:isedited?<div className="viewbbox">
        <div>{employeename}</div>
       {isdepartment?<div>
    <div className="row spacing">
        
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">laptop</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangelaptop(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Not Received">Not Received</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Condition</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangelaptopconditions(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Satisfactory">Satisfactory/Good</option>
                            <option value="Not Satisfactory">Not Satisfactory</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                       
    </div>
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Charger Adaptor</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangelaptopadaptor(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Not Received">Not Received</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Condition</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangelaptopadatorconditions(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Satisfactory">Satisfactory/Good</option>
                            <option value="Not Satisfactory">Not Satisfactory</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                       
    </div>
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Bag</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangelaptopbag(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Not Received">Not Received</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Condition</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangelaptopbagconditions(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Satisfactory">Satisfactory/Good</option>
                            <option value="Not Satisfactory">Not Satisfactory</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                       
    </div>
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Email ID</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="natureofenganement"
                            id="noengagement"
                            value={empemailid}
                            // onChange={(e) => setNatureofeng(e.target.value)}
                            placeholder="Nature of Engagement"
                            disabled
                          />
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Deactivated</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangeemaildeactive(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                       
    </div>
    <div className="row spacing">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <label htmlFor="lastname">Remarks</label>
                              </div>
                              <textarea
                                id="faultreport"
                                name="faultreport"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Write your message"
                                rows="4"
                                required
                              ></textarea>
                            </div>
                          </div>
     <div className="row">
                           
                            <input
                              type="radio"
                              name="verify"
                              value="verified"
                              id="verified"
                              checked={isverfiednew === "verified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Verified
                            <input
                              type="radio"
                              name="verify"
                              value="notverified"
                              id="notverified"
                              checked={isverfiednew === "notverified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Not Verified
                          </div>
                          <Button
                      variant="primary"
                      className="btns bts-submit"
                      type="submit"
                      value="Submit"
                      onClick={() => handleSubmit_it()}
                    >
                      Submit
                    </Button>
    </div>:''}
    {isadmin?<div>
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Food Card</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangefoodcard(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Not Received">Not Received</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">ID Card</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handlechangeidcard(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Not Received">Not Received</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                       
    </div>
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Workstation Drawer Key</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => workstationkey(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Received">Received</option>
                            <option value="Not Received">Not Received</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Bio Metric Punch</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => biometricpunch(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Removed">Removed</option>
                            
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                       
    </div>
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Main Gate Entry</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => maingatetry(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Removed">Removed</option>
                           
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
                               
    </div>
    <div className="row spacing">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <label htmlFor="lastname">Remarks</label>
                              </div>
                              <textarea
                                id="faultreport"
                                name="faultreport"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Write your message"
                                rows="4"
                                required
                              ></textarea>
                            </div>
                          </div>
    <div className="row">
                           
                            <input
                              type="radio"
                              name="verify"
                              value="verified"
                              id="verified"
                              checked={isverfiednew === "verified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Verified
                            <input
                              type="radio"
                              name="verify"
                              value="notverified"
                              id="notverified"
                              checked={isverfiednew === "notverified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Not Verified
                          </div><Button
                      variant="primary"
                      className="btns bts-submit"
                      type="submit"
                      value="Submit"
                      onClick={() => handleSubmit_admin()}
                    >
                      Submit
                    </Button></div>:''}
    {isreporting?
    <div className="row spacing">
       <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Pending Tasks / Work</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => pendingtask(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Completed">Completed</option>
                            <option value="Incompleted">Incompleted</option>
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>                         
        <div className="col-md-4">
       <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Handing Over</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handincoverfn(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Completed">Completed</option>
                            <option value="Incompleted">Incompleted</option>
                            
                           
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
        </div>    
        <div className="row spacing">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <label htmlFor="lastname">Remarks</label>
                              </div>
                              <textarea
                                id="faultreport"
                                name="faultreport"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Write your message"
                                rows="4"
                                required
                              ></textarea>
                            </div>
                          </div>                   
    <div className="row">
                           
                            <input
                              type="radio"
                              name="verify"
                              value="verified"
                              id="verified"
                              checked={isverfiednew === "verified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Verified
                            <input
                              type="radio"
                              name="verify"
                              value="notverified"
                              id="notverified"
                              checked={isverfiednew === "notverified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Not Verified
                          </div><Button
                      variant="primary"
                      className="btns bts-submit"
                      type="submit"
                      value="Submit"
                      onClick={() => handleSubmit_rm()}
                    >
                      Submit
                    </Button></div>:''}</div>:""}
    </div>
  );
};

export default ExitRequestForm;
